export default "__VITE_ASSET__DMhuns1g__"